import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";
import reelsetModifier from "utils/reelset-modifier";
import GameiomRequestSpin from "gameiom/states/gameiom-request-spin";

export class CGRequestSpin extends GameiomRequestSpin {
    public onEnter() {
        lightningBorderAnimationUtil.stop();
        reelsetModifier.updateMCSymbolValues("base");
        super.onEnter();
    }
}
